
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
import type MenuItem from '../SidePanel/types';
// import Topbar from '@/themes/Topbar/Topbar.vue';
import Topbar from '../Topbar/Topbar.vue';
// import overlay from '@/themes/Dialog/Overlay.vue';
import overlay from '../Dialog/Overlay.vue';
// import SidePanel from '@/themes/SidePanel/SidePanel.vue';
import SidePanel from '../SidePanel/SidePanel.vue';

import type {TopMenuItem, User, Breadcrumb} from '../Topbar/types';

export default defineComponent({
  name: 'OxdLayout',

  components: {
    'oxd-top-bar': Topbar,
    'oxd-overlay': overlay,
    'oxd-side-panel': SidePanel,
  },

  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
    sidepanelMenuItems: {
      type: Object as PropType<MenuItem[]>,
      required: true,
    },
    topbarMenuItems: {
      type: Object as PropType<TopMenuItem[]>,
      required: true,
    },
    breadcrumb: {
      type: Object as PropType<Breadcrumb>,
      required: true,
    },
    brandLogoSrc: {
      type: String,
      required: true,
    },
    brandBannerSrc: {
      type: String,
      required: true,
    },
    homeUrl: {
      type: String,
      required: false,
      default: '/',
    },
  },

  data() {
    return {
      collapse: false,
    };
  },

  computed: {
    containerClasses(): object {
      return {
        'oxd-layout-container': true,
        '--collapse': this.collapse,
      };
    },
  },

  methods: {
    onCollapse() {
      this.collapse = !this.collapse;
    },
  },
});
